/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Filter Drawer Expand All Icon component.
 */
export const FilterDrawerExpandAllIcon = ({
  color = dlsColor('grey1')
}: IconProps) => {
  const {iconSize, iconColor} = useIconDLS({color});
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M2.875 9.74998H12.375M2.875 5.74998H12.375M2.875 13.75H12.375M2.875 17.75H12.375M15.125 9.49998L18.045 5.60665C18.085 5.55332 18.165 5.55332 18.205 5.60665L21.125 9.49998M15.125 14.5L18.045 18.3933C18.085 18.4467 18.165 18.4467 18.205 18.3933L21.125 14.5' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' />
    </svg>
  );
};

export default FilterDrawerExpandAllIcon;
